<template>
  <div>
    <div class="modules-item dro" v-if="hasAccess" @click="openDetail()">
      <h3 class="modules-item__title">{{'dro.title' | trans}}</h3>
      <p class="modules-item__subtitle">{{'dro.description' | trans}}</p>

      <p class="modules-item__number">#1</p>
    </div>
  </div>
</template>

<script>
  import Manager from '../api/Manager';
  import isEmpty from 'lodash/isEmpty';
  import {mapState} from 'vuex';


  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return this.route.params.clientId || null;
        },
      },
    },

    data() {
      return {
        hasAccess: false
      }
    },

    components: {},

    computed: {
      ...mapState(['route']),
      ...mapState('dro/session', [
        'isSessionStarted',
      ]),
    },

    created() {
      this.checkAccess();
    },

    methods: {
      async checkAccess() {
        try {
          let response = await Manager.hasAccess(this.clientId);
          if (response && response.data) {
            if (response.data.data.hasAccess) {
              this.hasAccess = true;
              this.$emit('hasAccess');
            }

            this.$emit('isLoaded');
          } else {
            this.$emit('isLoaded');
            throw new Error('Unknown API error');
          }
        } catch (e) {
          this.$emit('isLoaded');
          console.error(e);
        }
      },
      openDetail() {
        if (this.isSessionStarted){
          this.$router.push({name: 'dro-session', params: this.route.params});
        } else{
          this.$router.push({name: 'dro', params: this.route.params});
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/ModuleItem.vue